import { gql } from '@apollo/client';

const CUSTOM_POPUP_FIELDS = gql`
  fragment CustomPopupFields on CustomPopupConfig {
    id
    name
    enabled
    place
    titleTexts
    bodyTexts
    buttonTexts
    buttonAction
    buttonUrl
    isSurveyLink
    backgroundImageUrl
    secondaryButtonTexts
    showSecondaryButton
    dontShowAgainTexts
    dontShowAgainPolicy
    uiTheme
    dailyCap
    targetUserIds
    platform
    minAppVersion
    maxAppVersion
    versionConditions
    countries
    languages
    minLevel
    maxLevel
    levelConditions
    payerStatus
    vipStatus
  }
`;

export const GET_CUSTOM_POPUPS = gql`
  ${CUSTOM_POPUP_FIELDS}
  query getCustomPopupConfigs {
    liveOps {
      customPopupConfigs {
        ...CustomPopupFields
      }
    }
  }
`;

export const CREATE_CUSTOM_POPUP = gql`
  ${CUSTOM_POPUP_FIELDS}
  mutation createCustomPopup($input: CustomPopupConfigInput!) {
    createCustomPopupConfig(input: $input) {
      ...CustomPopupFields
    }
  }
`;

export const UPDATE_CUSTOM_POPUP = gql`
  ${CUSTOM_POPUP_FIELDS}
  mutation updateCustomPopup($input: UpdateCustomPopupConfigInput!) {
    updateCustomPopupConfig(input: $input) {
      ...CustomPopupFields
    }
  }
`;

export const DELETE_CUSTOM_POPUP = gql`
  mutation deleteCustomPopup($id: ID!) {
    deleteCustomPopupConfig(id: $id)
  }
`;

export const GET_CUSTOM_POPUP_ASSETS = gql`
  query getCustomPopupAssets {
    liveOps {
      customPopupAssets {
        url
        filename
        updatedAt
      }
    }
  }
`;

export const UPLOAD_CUSTOM_POPUP_ASSET = gql`
  mutation uploadCustomPopupAsset($file: Upload!) {
    uploadCustomPopupAsset(file: $file) {
      url
    }
  }
`;
